/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node, Modal, ModalBody, ModalHeader, ModalFooter } from '@msdyn365-commerce-modules/utilities';
import React, { useEffect, useState } from 'react';
import { ModulesStateShareInput } from '../../themes/dobbies/actions/modules-state-share-action';
// import DobbiesModal from '../../themes/dobbies/views/custom-components/dobbies-modal';
// import { ISearchResultModalViewProps } from './components';
import MsDyn365, { Image } from '@msdyn365-commerce/core';
import classnames from 'classnames';
// import * as Msdyn365 from '@msdyn365-commerce/core';
import {
    // GridSize,
    ICategoryHierarchyViewProps,
    IRefineMenuViewProps,
    ISearchResultContainerViewProps,
    ITitleViewProps
} from './dobbies-search-result-container';
import { calculateScreenSize } from '../../themes/dobbies/utilities/display-utils';
// import Button from 'reactstrap/lib/Button';

interface ICategoryHierarchyProps {
    viewProps: ICategoryHierarchyViewProps;
    isMobile?: boolean;
}

export const getIsSearchPage = (context: any) => context?.request?.query?.q;
const SearchResultContainerView: React.FC<ISearchResultContainerViewProps> = props => {
    const {
        data: {
            category: { result: currentCategory }
        },
        SearchResultContainer,
        products,
        ProductsContainer,
        ProductSectionContainer,
        choiceSummary,
        isMobile,
        // modalToggle,
        // searchResultModal,
        TitleViewProps,
        refineMenu,
        categoryHierarchy,
        sortByOptions,
        CategoryNavContainer,
        RefineAndProductSectionContainer,
        errorMessage,
        FeatureSearchContainer,
        similarLookProduct,
        slots: { browse },
        // resources: { browseButtonText },
        pagination,
        refinersRef,
        totalProductCount,
        onClearFilters,
        selectedRefiners,
        hasRangeValidationError,
        selectedSortOption
    } = props;
    const [showModal, setShowModal] = useState(false); /* VSI-Customization -- START showModal Hook for managing state of showModal  */
    const [categoryTitle, SetCategoryTitle] = useState<string | undefined>(); // Following hook is used to store category name
    // const [shouldShowMoreRefiners, setShouldShowMoreRefiners] = useState(false);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const [screenSize, setScreenSize] = React.useState<number | null>(null);

    // Sort By Modal State
    const [isSortModalOpen, setIsSortModalOpen] = React.useState(false);
    const toggleSortModal = () => setIsSortModalOpen(!isSortModalOpen);

    useEffect(() => {
        document.documentElement.classList.toggle('filter-modal-open', isSortModalOpen || isModalOpen);
    }, [isSortModalOpen, isModalOpen]);

    // Scroll Direction State
    const [isScrollingUp, setIsScrollingUp] = React.useState(false);
    const lastScrollYRef = React.useRef(0);

    // Scroll to products top function
    const scrollToProductsTop = () => {
        if (window) {
            setTimeout(() => {
                const element = document.getElementById('plp-top-placeholder');

                if (element) {
                    const top = element.getBoundingClientRect().top + window.scrollY - 120;
                    window.scrollTo({
                        top: top,
                        behavior: 'smooth'
                    });
                }
            }, 500);
        }
    };

    // Handle View Results click for Filter Modal
    const handleFilterViewResults = () => {
        toggleModal();
        scrollToProductsTop();
    };

    // Handle View Results click for Sort By Modal
    const handleSortViewResults = () => {
        toggleSortModal();
        scrollToProductsTop();
    };
    const isIpad = screenSize === 2;

    // Helper function to get the appropriate banner image based on device type
    const getBannerImage = (
        desktopImage?: { src?: string },
        mobileImage?: { src?: string },
        ipadImage?: { src?: string }
    ): string | undefined => {
        if (isIpad && ipadImage?.src) {
            return ipadImage.src;
        }
        if (isMobile && mobileImage?.src && !isIpad) {
            return mobileImage.src;
        }
        return desktopImage?.src;
    };

    const plpBannerImageTop = getBannerImage(
        props.config.plpBannerImageDesktopTop,
        props.config.plpBannerImageMobileTop,
        props.config.plpBannerImageIpadTop
    );

    const plpBannerImageBottom = getBannerImage(
        props.config.plpBannerImageDesktopBottom,
        props.config.plpBannerImageMobileBottom,
        props.config.plpBannerImageIpadBottom
    );

    const plpBannerLinkTop = props.config.plpBannerLinkTop;
    const plpBannerLinkBottom = props.config.plpBannerLinkBottom;

    useEffect(() => {
        document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key.toLocaleLowerCase() === 'escape') {
                if (showModal) {
                    setShowModal(!showModal);
                }
            }
        });
        // Store categoryName in state data action to display it in category header
        if (categoryTitle === undefined) {
            const currentCategoryName = currentCategory && currentCategory.Name ? currentCategory.Name : '';
            props.context.actionContext.update(new ModulesStateShareInput(), { categoryName: currentCategoryName });
            SetCategoryTitle(currentCategoryName);
        }
    }, [showModal]);

    React.useEffect(() => {
        const updateSize = () => {
            setScreenSize(calculateScreenSize(window.innerWidth));
        };
        updateSize();
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    const isClickInsideElementByClassName = (className: string, event: MouseEvent): boolean => {
        let target: EventTarget | null = event.target;
        while (target && target !== document) {
            if ((target as Element).classList && (target as Element).classList.contains(className)) {
                return true;
            }
            target = (target as Node).parentNode;
        }
        return false;
    };

    useEffect(() => {
        document.body.addEventListener(
            'click',
            evt => {
                const filtersDivs = document.getElementsByClassName('new-filter__filter-section');
                if (filtersDivs && filtersDivs.length) {
                    if (
                        !isClickInsideElementByClassName('new-filter__filter-section', evt) &&
                        !isClickInsideElementByClassName('ms-product-search-result__item', evt)
                    ) {
                        if (props.onMoreFiltersClicked) {
                            props.onMoreFiltersClicked(undefined, false, true);
                        }
                    }
                }
            },
            true
        );
    }, []);

    // Scroll Direction Effect
    useEffect(() => {
        const handleScroll = (): void => {
            const currentScrollY = window.scrollY;

            if (currentScrollY < lastScrollYRef.current) {
                // Scrolling up
                setIsScrollingUp(true);
            } else {
                // Scrolling down
                setIsScrollingUp(false);
            }

            lastScrollYRef.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    //     const { category } = props.data;
    //     const categoryName = category && category.result && category.result.Name;
    //     const handleShowModal = () => setShowModal(!showModal);
    //     return (
    //         <Node tag='div' className='view-all-popup-header'>
    //             <Node tag='span' className='title-text'>
    //                 {categoryName}
    //             </Node>
    //             <div className='header-close-button' onClick={handleShowModal} role='button'>
    //                 <i className='msc-modal__close-button' />
    //             </div>
    //         </Node>
    //     );
    // };

    // const modalFooter = (): JSX.Element => {
    //     const handleShowModal = () => setShowModal(!showModal);
    //     return <div className='close-button' role='button' onClick={handleShowModal} />;
    // };
    // const _modalToggle = () => {
    //     setShowModal(!showModal);
    // };
    // const renderToggle = (slotBrowse: React.ReactNode): JSX.Element | undefined => {
    //     // const handleShowModal = () => setShowModal(!showModal);
    //     return (
    //         <>
    //             <div className='category-list-mobile'>{/* <button onClick={handleShowModal}>{browseButtonText}</button> */}</div>
    //             <DobbiesModal
    //                 className='modal ms-dobbies-browse'
    //                 isOpen={showModal}
    //                 modalBodySlots={browse}
    //                 onModalToggle={_modalToggle}
    //                 modalTitle={modalTitle()}
    //                 modalFooter={modalFooter()}
    //             />
    //         </>
    //     );
    // };
    const redirectUrl =
        props.data.products.result?.products &&
        props.data.products.result?.products.length > 0 &&
        props.data.products.result?.products[0].ExtensionProperties?.find(item => item.Key === 'RedirectURL');
    let shouldRedirect = false;
    if (props.data.products.result?.count === 0 && redirectUrl && redirectUrl.Value?.StringValue) {
        shouldRedirect = true;
    }
    const isSearchPage = getIsSearchPage(props.context);
    let hasContentBlockTitle = false;
    if (MsDyn365.isBrowser && window) {
        const categoryBanners = document.getElementsByClassName('ms-content-block category-banner');
        if (categoryBanners && categoryBanners.length) {
            const contentBlockTitleDivs = document.getElementsByClassName('ms-content-block__title');
            if (contentBlockTitleDivs && contentBlockTitleDivs.length && contentBlockTitleDivs[0].innerHTML) {
                hasContentBlockTitle = true;
            }
        }
    }

    return !shouldRedirect ? (
        <Module {...SearchResultContainer}>
            <div id='plp-top-placeholder'></div>
            {/* {!collectionTitle && <h1 className='top-title'>{categoryName} </h1>} */}
            <Node {...CategoryNavContainer}>
                {/* {renderOutOfStockBtn(props)} */}
                {/* {outOfStock && renderOOSBtn(props)} */}
                {categoryHierarchy && MsDyn365.isBrowser && <CategoryHierarchy viewProps={categoryHierarchy} isMobile={isMobile} />}{' '}
                {(isSearchPage || !hasContentBlockTitle) && TitleViewProps && renderTitleAndProductCount(TitleViewProps, props)}
            </Node>
            {plpBannerImageTop && (
                <a
                    href={plpBannerLinkTop?.linkUrl.destinationUrl}
                    target={plpBannerLinkTop?.openInNewTab ? '_blank' : '_self'}
                    aria-label={plpBannerLinkTop?.ariaLabel}
                    rel='noreferrer'
                >
                    <Image
                        src={plpBannerImageTop}
                        gridSettings={props.context.request.gridSettings!}
                        className='create-account-banner'
                        loadFailureBehavior='default'
                    />
                </a>
            )}
            <Node {...RefineAndProductSectionContainer} ref={refinersRef}>
                {/* Filter Modal */}
                <Modal isOpen={isModalOpen} className='filter-popup__dialog' toggle={toggleModal}>
                    <ModalHeader className='filter-popup__header' toggle={toggleModal}>
                        <h5 className='filter-popup__title'>Filters</h5>
                    </ModalHeader>
                    <ModalBody>{renderRefiner(refineMenu)}</ModalBody>
                    <ModalFooter className='filter-popup__actions'>
                        <button
                            className='clear-filters-button msc-btn'
                            onClick={onClearFilters}
                            disabled={!selectedRefiners || selectedRefiners.length === 0}
                        >
                            Clear Filters
                        </button>
                        <button
                            className='apply-filters-button msc-btn'
                            onClick={handleFilterViewResults}
                            disabled={totalProductCount === 0 || hasRangeValidationError}
                        >
                            View {totalProductCount} {totalProductCount === 1 ? 'result' : 'results'}
                        </button>
                    </ModalFooter>
                </Modal>
                {/* Sort By Modal */}
                <Modal isOpen={isSortModalOpen} toggle={toggleSortModal} className='sort-by-popup__dialog'>
                    <ModalHeader className='sort-by-popup__header' toggle={toggleSortModal}>
                        <h5 className='sort-by-popup__title'>Sort by</h5>
                    </ModalHeader>
                    <ModalBody className='sort-by-popup__body'>
                        {sortByOptions?.sortOptions &&
                            sortByOptions.sortOptions.map((option, index) => (
                                <div
                                    key={option.key}
                                    className={`sort-by-option ${
                                        sortByOptions.selectedSortOption?.key === option.key ? 'sort-by-option--selected' : ''
                                    }`}
                                >
                                    <label className='sort-by-option__label'>
                                        <input
                                            type='radio'
                                            name='sortOption'
                                            value={option.key}
                                            checked={sortByOptions.selectedSortOption?.key === option.key}
                                            onChange={() => {
                                                if (sortByOptions.onSortOptionSelect) {
                                                    sortByOptions.onSortOptionSelect(option);
                                                }
                                            }}
                                            className='sort-by-option__radio'
                                        />
                                        <span className='sort-by-option__text'>{option.value}</span>
                                    </label>
                                </div>
                            ))}
                    </ModalBody>
                    <ModalFooter className='sort-by-popup__footer'>
                        <button className='sort-by-view-results-button' onClick={handleSortViewResults} disabled={totalProductCount === 0}>
                            View {totalProductCount} {totalProductCount === 1 ? 'result' : 'results'}
                        </button>
                    </ModalFooter>
                </Modal>
                <Node {...ProductSectionContainer}>
                    {isSearchPage && totalProductCount !== undefined && totalProductCount === 0 ? null : (
                        <div className={classnames('ms-search-result-container__sticky-wrapper', { 'scroll-up': isScrollingUp })}>
                            {!isSearchPage && (
                                <div className='new-filter'>
                                    <div className='new-filter__refiner-section'>
                                        <div className='category-listing'>{browse}</div>
                                    </div>
                                </div>
                            )}
                            {/* Filter and Sort CTA buttons */}
                            <div className={classnames('ms-search-result-container__filter-sort-actions', { 'search-page': isSearchPage })}>
                                {!isSearchPage && (
                                    <div className='ms-search-result-container__product-count-ipad'>
                                        {totalProductCount} {totalProductCount === 1 ? 'result' : 'results'}
                                    </div>
                                )}
                                <button className='ms-search-result-container__filter-button' onClick={toggleModal}>
                                    Filter <span className='count'>{selectedRefiners?.length ? ` (${selectedRefiners.length})` : ''}</span>
                                    <span className='ms-search-result-container__filter-button-icon' />
                                </button>
                                <button className='ms-search-result-container__sort-button' onClick={toggleSortModal}>
                                    Sort by
                                    <span className='ms-search-result-container__sort-button-icon' />
                                </button>
                            </div>
                            <div className='ms-search-result-container__choice-summary-wrapper'>{choiceSummary}</div>
                        </div>
                    )}

                    {/* Choice summary */}

                    <div
                        className={`ms-search-result-container__choice-summary-wrapper mobile ${
                            selectedSortOption?.value === 'Relevance' && selectedRefiners && selectedRefiners.length === 0
                                ? 'no-filter-ipad'
                                : ''
                        } ${isSearchPage ? 'searchPage' : ''}`}
                    >
                        {choiceSummary}
                    </div>

                    <Node {...FeatureSearchContainer}>{similarLookProduct}</Node>
                    <Node {...ProductsContainer}>
                        {errorMessage}
                        {products}

                        {totalProductCount !== undefined && totalProductCount > 0 && pagination}
                    </Node>
                    {((props.slots.unbxdCarousel && props.slots.unbxdCarousel?.length > 0) || plpBannerImageBottom) && (
                        <div className={`ms-search-result-container__create-account-banner`}>
                            {plpBannerImageBottom ? (
                                <a
                                    href={plpBannerLinkBottom?.linkUrl.destinationUrl}
                                    target={plpBannerLinkBottom?.openInNewTab ? '_blank' : '_self'}
                                    aria-label={plpBannerLinkBottom?.ariaLabel}
                                    rel='noreferrer'
                                >
                                    <Image
                                        src={plpBannerImageBottom}
                                        gridSettings={props.context.request.gridSettings!}
                                        loadFailureBehavior='default'
                                        className='create-account-banner'
                                    />
                                </a>
                            ) : null}

                            {props.slots.unbxdCarousel && props.slots.unbxdCarousel?.length > 0 && (
                                <div className='unbxd-recommendations'>{props.slots.unbxdCarousel}</div>
                            )}
                        </div>
                    )}
                </Node>
            </Node>
        </Module>
    ) : (
        <></>
    );
};

const renderRefiner = (props: IRefineMenuViewProps): JSX.Element | null => {
    const { refiners, RefineMenuContainer, RefinerSectionContainer } = props;

    if (refiners) {
        return (
            <>
                <Node {...RefinerSectionContainer}>
                    <div>
                        <Node {...RefineMenuContainer}>
                            <div className='new-filter__filter-section'>
                                <div className={`filter-list`}>
                                    {/* Render refiners directly - they already have stable keys */}
                                    {refiners}
                                </div>
                            </div>
                        </Node>
                    </div>
                </Node>
            </>
        );
    }
    return null;
};

const getCategoryName = (category: React.ReactNode): string => {
    const el = category as React.ReactElement<{ text?: string }>;
    return el && el.props && el.props.text ? String(el.props.text) : '';
};

const CategoryHierarchy: React.FC<ICategoryHierarchyProps> = ({ viewProps, isMobile }) => {
    const isCategoryPage = MsDyn365.isBrowser && window.location.pathname.includes('.c');
    const { CategoryHierarchyContainer, categoryHierarchyList, categoryHierarchySeparator } = viewProps;
    const [expanded, setExpanded] = React.useState(false);

    const homeIconElement = isCategoryPage ? (
        <a className='home-breadcrumb' key='home-breadcrumb' href='/'>
            <span className='icon--home' aria-hidden='true' />
        </a>
    ) : null;

    const fullBreadcrumbList: React.ReactNode[] = homeIconElement
        ? [homeIconElement, ...(categoryHierarchyList || [])]
        : [...(categoryHierarchyList || [])];
    const [breadcrumbList] = React.useState<React.ReactNode[] | undefined>(fullBreadcrumbList);

    // Guard: Ensure all required data is loaded before rendering
    if (!categoryHierarchyList || categoryHierarchyList.length === 0 || !CategoryHierarchyContainer) {
        return null;
    }

    // Guard: Ensure home icon dependencies are available on category page
    if (isCategoryPage && !categoryHierarchySeparator) {
        return null;
    }

    const totalLength = categoryHierarchyList.reduce<number>((acc, category) => acc + getCategoryName(category).length, 0);
    const validCharacterLength = totalLength <= 35;

    const shouldCollapse = Boolean(isMobile) && !expanded && !validCharacterLength && categoryHierarchyList.length > 2;

    const handleExpandClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setExpanded(true);
    };

    if (shouldCollapse) {
        // For collapsed view: home icon + first category + ellipsis + last category
        const firstCategory = categoryHierarchyList[0];
        const lastCategory = categoryHierarchyList[categoryHierarchyList.length - 1];

        return (
            <Node
                {...CategoryHierarchyContainer}
                className={classnames(CategoryHierarchyContainer.className, 'category-hierarchy-collapsed')}
            >
                {homeIconElement}
                {homeIconElement && categoryHierarchySeparator}
                <Node className='category-hierarchy__expand' role='button' onClick={handleExpandClick}>
                    {firstCategory}
                </Node>
                {categoryHierarchySeparator}
                <Node className='category-hierarchy__ellipsis' role='button' onClick={handleExpandClick}>
                    …
                </Node>
                <Node className='category-hierarchy__last'>{lastCategory}</Node>
            </Node>
        );
    }

    // Render all breadcrumb items (including home icon) with separators between them
    return (
        <Node {...CategoryHierarchyContainer}>
            {breadcrumbList?.map((item, index) => (
                <React.Fragment key={index}>
                    {item}
                    {breadcrumbList[index + 1] && categoryHierarchySeparator}
                </React.Fragment>
            ))}
        </Node>
    );
};

const renderTitleAndProductCount = (props: ITitleViewProps, srcProps: ISearchResultContainerViewProps): JSX.Element | null => {
    const { title, TitleContainer } = props;
    const isSearchPage = getIsSearchPage(srcProps.context);
    if (title) {
        return (
            <Node {...TitleContainer}>
                {isSearchPage ? (
                    <>
                        <h2>
                            {title.titlePrefix} {title.titleText}
                        </h2>
                        <p>{title.titleCount}</p>
                    </>
                ) : (
                    <>
                        <h1>{title.titleText}</h1>
                    </>
                )}
            </Node>
        );
    }
    return null;
};

export default SearchResultContainerView;
